// extracted by mini-css-extract-plugin
export default {"root":"StatisticCard_root__623Ii","value":"StatisticCard_value__0VVYo"};